import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@sbv-clients/ui-shared';

import { useDashboardAbsenceRequestsCountGet } from '../../../services/dashboard';
import Counter from './counter';

interface PendingAbsenceRequestCounterProps {
  departmentId?: number;
  positionId?: number;
}

const PendingAbsenceCounter = ({
  departmentId,
  positionId,
}: PendingAbsenceRequestCounterProps) => {
  const theme = useTheme();
  const data = useDashboardAbsenceRequestsCountGet(departmentId, positionId);
  const count = data.data?.data?.count || 0;

  const navigate = useNavigate();

  const goToEmployeesPageWithHasAbsenceRequestsFilter = useCallback(() => {
    navigate(
      '/employees/profile/planned-absences?hasPendingAbsenceRequests=true'
    );
  }, [navigate]);

  return (
    <Counter
      title="Pending Absence Requests"
      counterValue={count}
      onClick={goToEmployeesPageWithHasAbsenceRequestsFilter}
      backgroundColor={theme.colors.primary.light}
    />
  );
};

export default PendingAbsenceCounter;
